import { useState, useEffect, useCallback } from "react";
import { useLocation, useHistory } from "react-router-dom";

import { makeStyles } from "@material-ui/core/styles";
import {
  Button,
  Box,
  Container,
  Grid,
  Card,
  CardContent,
  CardHeader,
  Divider,
} from "@material-ui/core";

import UtilsFncs from "utils/UtilsFncs";
import Api from "lib/api/httpRequestHelper";
import useSnackbar from "components/Alerts/Snackbar/useSnackbar";
import HeaderClientes from "components/_refactor/headers/clients";
import PeriodField from "components/_refactor/fields/period-field";
import InputText from "components/_refactor/text/input";
import componentStyles from "assets/theme/views/admin/react-bs-table";
import componentStylesCardDeck from "assets/theme/components/cards/card-deck";
import MaskAndValid from "utils/maskAndValid";
import StructureFields from "components/_refactor/fields/structure";
import ClearButton from "components/_refactor/button/clear";
import LoadingData from "components/Loading/LoadingData";
import TableTrocasDevolucoes from "./table/TableTrocasDevolucoes";
import useLogs from "hooks/logs";
import { IsMobile900, IsMobile } from "utils/is-mobile";

const useStyles = makeStyles(componentStyles);
const useStylesCardDeck = makeStyles(componentStylesCardDeck);
const useCustomStyles = makeStyles({
  option: {
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    wordBreak: "keep-all",
  },
  paper: {
    width: "max-content !important",
    minWidth: "100%",
  },
  popper: {
    maxWidth: "calc(100% - 60px - 1.5rem)",
    width: "max-content",
  },
});

const dataHoje = new Date().toISOString().slice(0, 10);

function TrocasDevolucoes() {
  const classes = {
    ...useStyles(),
    ...useStylesCardDeck(),
    ...useCustomStyles(),
  };
  const snackbar = useSnackbar();
  const location = useLocation();
  const history = useHistory();
  const { setLocalStorageApiProblem, setLocalStorageActions } = useLogs();

  const isMobile900 = IsMobile900();
  const isMobile = IsMobile();

  const itemXS = isMobile ? 12 : isMobile900 ? 6 : 3;

  const [periodo, setPeriodo] = useState(null);
  const [dataInicial, setDataInicial] = useState(dataHoje);
  const [dataFinal, setDataFinal] = useState();
  const [nrNotaVenda, setNrNotaVenda] = useState("");
  const [cpfConsumidor, setCpfConsumidor] = useState("");
  const [nrPedido, setNrPedido] = useState("");
  const [nrTroca, setNrTroca] = useState("");

  const [resultados, setResultados] = useState(null);
  const [pesquisando, setPesquisando] = useState(false);

  const [structureFilters, setStructureFilters] = useState({});
  const [structureLoading, setStructureLoading] = useState([]);
  const [validateButton, setValidateButton] = useState(false);
  const [clearFilters, setClearFilters] = useState(false);
  const [cancelLoading, setCancelLoading] = useState(false);
  const [hasNoStoreSingle, setHasNoStoreSingle] = useState(false);

  const [firstSearch, setFirstSearch] = useState(false);
  const [totalRegisters, setTotalRegisters] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [currentSizePerPage, setCurrentSizePerPage] = useState(25);

  const handleSearch = async ({
    numeroTroca,
    numeroPedido,
    cpf,
    page = 1,
    sizePerPage = 25,
  }) => {
    setPesquisando(true);
    setCancelLoading(false);
    setResultados([]);

    await Api.get(
      "list-order-change-product",
      "trocas",
      `?page=${page - 1}&pageSize=${sizePerPage}` +
        "&idRepresentante=" +
        (structureFilters?.idRepresentante
          ? structureFilters?.idRepresentante
          : "") +
        "&idMarca=" +
        (structureFilters?.idMarca ? structureFilters?.idMarca : "TODAS") +
        "&idCanal=" +
        (structureFilters?.idCanal ? structureFilters?.idCanal : "") +
        "&idGrupoEconomico=" +
        (structureFilters?.idGrupoEconomico
          ? structureFilters?.idGrupoEconomico
          : "") +
        "&idPessoaLoja=" +
        (structureFilters?.idLojaUnica ? structureFilters?.idLojaUnica : "") +
        "&idNota=" +
        nrNotaVenda +
        "&idNumeroTroca=" +
        (numeroTroca || nrTroca) +
        "&cpfCnpj=" +
        (MaskAndValid.maskCPF(cpfConsumidor) || cpf || "") +
        "&idPedido=" +
        (numeroPedido || nrPedido) +
        `&dtIni=${dataInicial}&dtFim=${dataFinal}`,
      true
    )
      .then((res) => {
        history.push(`/admin/trocas-devolucoes-prateleira-infinita`);
        if (res?.Result) {
          setResultados(res?.Result?.ListaPedidoTrocaDevolucao);
        }
        setCurrentPage(page);
        setCurrentSizePerPage(sizePerPage);
        setTotalRegisters(res?.Result?.TotalRegistros);
      })
      .catch((error) => {
        console.log(error);
        snackbar.showMessage(error, {
          severity: "error",
        });
        setLocalStorageApiProblem({
          idMenuAccess: "153",
          screen: "Trocas / Devoluções Prateleira Infinita",
          problem: `Erro na chamada do endpoint list-order-change-product - ${error}`,
        });
      })
      .finally(() => {
        setPesquisando(false);
      });
  };

  const handleClearFilters = () => {
    setClearFilters(true);
    setPesquisando(true);
    setStructureLoading(true);
    setNrNotaVenda("");
    setCpfConsumidor("");
    setNrPedido("");
    setNrTroca("");
    setDataInicial(dataHoje);
    setDataFinal(undefined);
    setPeriodo(null);
    setPesquisando(false);
    setStructureLoading(false);
  };

  const handleStopSearching = () => {
    setCancelLoading(true);
    setPesquisando(false);
    setResultados(null);
  };

  const handleVerifyRequiredInputs = () => {
    if (
      structureFilters.idLojaUnica !== "" ||
      nrPedido ||
      cpfConsumidor ||
      nrTroca ||
      nrNotaVenda
    ) {
      setLocalStorageActions({
        nomeTela: "Trocas / Devoluções Prateleira Infinita",
        idMenu: "153",
        acao: "Clicou para Pesquisar",
      });
      return handleSearch({
        page: 1,
        sizePerPage: currentSizePerPage,
      });
    } else {
      if (
        !structureFilters.idLojaUnica &&
        !nrPedido &&
        !cpfConsumidor &&
        !nrTroca &&
        !nrNotaVenda
      ) {
        setHasNoStoreSingle(true);
      }
    }
  };

  const triggerAutoSearch = useCallback(
    async (numeroPedido, numeroTroca, cpf) => {
      setResultados(null);
      setPesquisando(true);

      await handleSearch({
        numeroTroca,
        numeroPedido,
        cpf,
        page: 1,
        sizePerPage: currentSizePerPage,
      });
      setPesquisando(false);
    },
    [handleSearch]
  );

  useEffect(() => {
    if (location.search) {
      const { numeroPedido, numeroTroca, cpf } = UtilsFncs.GetUrlSearchParams(
        location.search
      );
      if (numeroPedido || numeroTroca || cpf) {
        triggerAutoSearch(numeroPedido, numeroTroca, cpf);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search]);

  useEffect(() => {
    if (
      !firstSearch &&
      structureFilters?.idLojaUnica !== "" &&
      structureFilters?.idLojaUnica !== undefined
    ) {
      setPesquisando(true);
      setTimeout(() => {
        setFirstSearch(true);
        handleSearch({
          page: 1,
          sizePerPage: currentSizePerPage,
        });
      }, 750);
    }
  }, [structureFilters.idLojaUnica]);

  useEffect(() => {
    setValidateButton(structureLoading.length > 0 || pesquisando);
  }, [pesquisando, structureLoading.length, validateButton]);

  useEffect(() => {
    if (
      structureFilters.idLojaUnica !== "" ||
      nrPedido ||
      cpfConsumidor ||
      nrTroca ||
      nrNotaVenda
    ) {
      setHasNoStoreSingle(false);
    }

    if (
      structureFilters?.idMarca === null &&
      structureFilters?.idCanal === "" &&
      structureFilters?.idRepresentante === "" &&
      structureFilters?.idLojaUnica === ""
    ) {
      setClearFilters(false);
    }
  }, [
    structureFilters,
    pesquisando,
    structureLoading,
    nrNotaVenda,
    cpfConsumidor,
    nrPedido,
    nrTroca,
    dataFinal,
    dataInicial,
    periodo,
  ]);

  return (
    <>
      <HeaderClientes
        section="Trocas / Devoluções Prateleira Infinita"
        subsection="Pedidos"
      />
      <Container style={{ marginTop: "-4.5rem" }} maxWidth={false}>
        <Grid container>
          <Grid item xs={12}>
            <Card classes={{ root: classes.cardRoot }}>
              <CardHeader
                className={classes.cardHeader}
                title="Filtros"
                titleTypographyProps={{
                  component: Box,
                  marginBottom: "0!important",
                  variant: "h3",
                }}
              ></CardHeader>
              <CardContent>
                <Grid container spacing={2} alignItems="center">
                  <StructureFields
                    fieldsOrder={["economicGroup", "storeSingle"]}
                    clearFilters={clearFilters}
                    onStructureFieldsChange={setStructureFilters}
                    disableAll={pesquisando}
                    onStructureFieldsLoad={setStructureLoading}
                    requiredFields={["storeSingle"]}
                    hasNoStoreSingle={hasNoStoreSingle}
                    showSingleStore={true}
                    handleSearch={handleVerifyRequiredInputs}
                    hideFields={["store"]}
                  />

                  <Grid item xs={12}>
                    <Divider style={{ margin: "0.5rem 0" }} />
                  </Grid>

                  <Grid item xs={itemXS}>
                    <InputText
                      label="CPF/CNPJ Consumidor"
                      value={
                        cpfConsumidor?.length <= 13
                          ? MaskAndValid.maskCPF(cpfConsumidor)
                          : cpfConsumidor?.length > 14
                          ? MaskAndValid.maskCNPJ(cpfConsumidor)
                          : cpfConsumidor
                      }
                      onChange={(e) => {
                        setCpfConsumidor(e.target.value.slice(0, 18));
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          handleVerifyRequiredInputs();
                        }
                      }}
                      disabled={pesquisando}
                    />
                  </Grid>

                  <Grid item xs={itemXS}>
                    <InputText
                      label="Nº Pedido Prateleira"
                      value={nrPedido}
                      onChange={(e) => {
                        setNrPedido(e.target.value.slice(0, 14));
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          handleVerifyRequiredInputs();
                        }
                      }}
                      disabled={pesquisando}
                    />
                  </Grid>

                  <Grid item xs={itemXS}>
                    <InputText
                      label="Nº Troca"
                      value={nrTroca}
                      onChange={(e) => {
                        setNrTroca(e.target.value.slice(0, 14));
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          handleVerifyRequiredInputs();
                        }
                      }}
                      disabled={pesquisando}
                    />
                  </Grid>

                  <Grid item xs={periodo?.value === "Outros" ? "12" : itemXS}>
                    <PeriodField
                      label="Período"
                      value={periodo}
                      onChange={setPeriodo}
                      initialDate={dataInicial}
                      finalDate={dataFinal}
                      setInitialDate={setDataInicial}
                      setFinalDate={setDataFinal}
                      disabled={pesquisando}
                    />
                  </Grid>
                </Grid>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <Button
                      style={
                        isMobile || isMobile900
                          ? {
                              width: "100%",
                              marginBottom: "0.75rem",
                              marginTop: "0.75rem",
                            }
                          : { marginBottom: "0rem" }
                      }
                      variant="contained"
                      onClick={handleVerifyRequiredInputs}
                      disabled={validateButton}
                    >
                      {pesquisando ? "Pesquisando..." : "Pesquisar"}
                    </Button>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <ClearButton
                      disable={pesquisando || structureLoading.length > 0}
                      onClick={() => handleClearFilters()}
                      fullWidth={true}
                    />
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
            <LoadingData
              searching={pesquisando}
              onClick={() => handleStopSearching()}
              classes={classes.root}
              label="Buscando dados..."
            />
          </Grid>
        </Grid>
        {!pesquisando && resultados && !cancelLoading && (
          <TableTrocasDevolucoes
            dataTable={resultados}
            totalRegistros={totalRegisters}
            currentPage={currentPage}
            currentSizePerPage={currentSizePerPage}
            search={handleSearch}
          />
        )}
      </Container>
    </>
  );
}

export default TrocasDevolucoes;
